export default {
  customWidgets: [],
  chartData: {},
  loadingCustomWidgets: [],
};
